import React from "react";

import { StyledLine } from "./styles";

const Line = () => {
  return <StyledLine />;
};

export default Line;
